import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import CustomModal from "../custom-modal";
import { Banner } from "../../types/home-page";
import { CloseIcon } from "../../assets/icons";

export default function BannersModal({
    isOpen,
    setIsOpen,
    banners,
}: {
    isOpen: boolean;
    setIsOpen: (isOpen: boolean) => void;
    banners: Banner[] | undefined;
}) {
    const [active, setActive] = useState(0);
    const navigate = useNavigate();

    useEffect(() => {
        if (!banners || banners.length === 0) return;
        if (active >= banners.length) setActive(0);
    }, [banners, active]);

    if (!banners || banners.length === 0) return null;

    const banner = banners[active];

    const onClose = () => {
        try {
            localStorage.setItem("zabehaty_home_banners_shown", "1");
        } catch (e) {
            // ignore
        }
        setIsOpen(false);
    };

    const onClickBanner = () => {
        if (!banner) return;
        if (banner.page === "product" && banner.table_id) {
            navigate(`/product/${banner.table_id}`);
        } else if (banner.link) {
            window.open(banner.link, "_blank");
        }
        onClose();
    };

    return (
        <div className={""}>
            <CustomModal isOpen={isOpen} setIsOpen={setIsOpen} maxWidth="!max-w-[900px] md:!max-w-[1400px] lg:!max-w-[1600px] xl:!max-w-[1800px]">
                <div className="relative p-6 md:p-8">
                    <button
                        aria-label="close"
                        className="absolute right-4 top-4 z-30  p-2 hover:scale-105 transition-transform md:right-6 md:top-6 focus:outline-none focus:ring-2 focus:ring-primary"
                        onClick={onClose}
                    >
                        <CloseIcon />
                    </button>

                    <div className="mx-auto w-full max-w-[900px] md:max-w-[1400px] lg:max-w-[1600px] xl:max-w-[1800px]">
                        <div
                            className="cursor-pointer w-full rounded overflow-hidden"
                            onClick={onClickBanner}
                        >
                            <img
                                src={banner.image}
                                alt={banner.title || "banner"}
                                className="w-full h-auto max-h-[80vh] md:max-h-[90vh] lg:max-h-[95vh] object-cover rounded"
                            />
                        </div>

                        {banners.length > 1 && (
                            <div className="mt-4 flex items-center justify-center gap-2">
                                {banners.map((_, idx) => (
                                    <button
                                        key={idx}
                                        onClick={() => setActive(idx)}
                                        className={`h-2 w-8 rounded-full transition-all duration-150 ${active === idx
                                                ? "bg-black"
                                                : "bg-gray-300"
                                            }`}
                                    />
                                ))}
                            </div>
                        )}
                    </div>
                </div>
            </CustomModal>
        </div>
    );
}
